const signin = resolve => {
  require(["./components/signin/index.vue"], resolve);
};
const framepage = resolve => {
  require(["./components/appframe/index.vue"], resolve);
};
const getInfo = resolve => {
  require(["./components/appframe/getInfo.vue"], resolve);
};
const loginSuccess = resolve => {
  require(["./components/appframe/loginSuccess.vue"], resolve);
};
// 招生问卷
const transfer = resolve => {
  require(["./components/research/transfer.vue"], resolve);
};
const research = resolve => {
  require(['./components/research/index.vue'], resolve)
}
import demo from "./demo/router.js";

const list = [
  { path: "/", component: framepage },
  { path: "/signin", component: signin },
  { path: "/getInfo", component: getInfo },
  { path: "/loginSuccess", component: loginSuccess },
  {path: "/transfer", component: transfer},
  {path: "/research", component: research},
  ...demo
];

export default list; // 给当前模块使用

export { list }; // 给 portal 使用



// WEBPACK FOOTER //
// ./src/router.js